var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sBadge',{attrs:{"color":"var(--black-color)","content":"AI","data-qa":"badge-ai","inner-styles":"padding: 2px 6px; height: 14px; font-size: 10px;","offset-x":_vm.offsetX,"offset-y":_vm.offsetY,"overlap":"","text-color":"var(--alert-success-icon)","value":_vm.visible}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }